<template>
  <div class="flex flex-row overflow-hidden h-full">
    <div class="tabs w-1/3 overflow-auto bg-grey-lightest border-r">
      <ul class="p-0 text-left">
        <li v-for="tab in tabs" :key="tab.href" :class="{ 'bg-white': tab.isActive }">
          <a
            :href="tab.href"
            @click.prevent="selectTab(tab)"
            :class="tab.isActive ? 'text-brand font-medium border-brand' : 'text-black border-transparent hover:bg-white'"
            class="no-underline block px-3 py-2 text-sm flex justify-between items-center border-l-4"
          >
            <span class="truncate">{{ tab.name }}</span>
            <span
              v-if="countSelectedTag(tab) != 0"
              class="ml-2 px-2 py-px rounded-full text-xs font-semibold bg-brand text-white"
            >
              {{ countSelectedTag(tab) }}
            </span>
          </a>
        </li>
      </ul>
    </div>
    <div class="tabs-details px-4 py-2 bg-white w-2/3 pb-8">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["file-data"],

  data() {
    return { tabs: [] };
  },

  created() {
    this.tabs = this.$children;
  },

  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = tab.href == selectedTab.href;
      });
    },

    countSelectedTag(tab) {
      if (!_.isEmpty(this.fileData) && !_.isEmpty(tab.category)) {
        let file_tags = this.fileData.file.tags;
        let count = 0;
        _.each(file_tags, (tag) => {
          count += _.filter(tab.category.tags, { id: tag.id }).length;
        });

        return count;
      }

      return false;
    },
  },
};
</script>

<style>
.tabs-details {
  /* height: 00px; */
  overflow-y: scroll;
}
</style>
